import { toDayJs } from '~/services/TimeService';

export function formatDateRange(start: string, end: string): string {
  const s = toDayJs(start);
  const e = toDayJs(end);
  if (s.isSame(e, 'day')) return s.format('DD MMM');
  if (s.month() === e.month()) return `${s.format('DD')}–${e.format('DD MMM')}`;
  return `${s.format('DD MMM')} – ${e.format('DD MMM')}`;
}

export function countNights(start: string, end: string): number {
  return toDayJs(end).diff(toDayJs(start), 'day');
}
